import { useState, useEffect } from "react";

/**
 * ### 実行環境がクライアント(ブラウザ)かどうか判定するフック
 * - 事前レンダリングの結果とCSRの結果が異なり、開発環境で React Hydration Error になるので抑制するため
 * @see https://nextjs.org/docs/messages/react-hydration-error
 */
export const useClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};
